import { render, staticRenderFns } from "./admission.vue?vue&type=template&id=63acad35&"
import script from "./admission.vue?vue&type=script&lang=js&"
export * from "./admission.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports